//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { LIBRARYCCPService } from 'src/app/Services/Libraries/General-CCP/library-ccp.service';


//-================ IMPORTS FOR CONSTANTS ================-\\
import { Download_Log_CCP } from 'src/app/Constants/Backlog/CCP/Download_Log';


//-================ IMPORTS FOR DEPENDENCIES ================-\\
import { saveAs } from 'file-saver';
import moment from 'moment';
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { Filter_Check_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Filter_Check_CCP.interface';
import { PermisionsFolderService } from 'src/app/Services/Global/Permissions/permisions-folder.service';
import { VH_FILE_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Version_History.interface';
import { Headers_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Headers-CCP.interface';
import { Response_CCP } from 'src/app/Interfaces/Interfaces-Global/Response.interface';
import { Permission, Permissions } from 'src/app/Constants/Admin/Permissions';
import { Permission_Folder_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Permissions/Permission_CCP.interface';
import { permissionSystemFolderCCP, PermissionSystemFolderCCPType, tpermissionFolderCCP } from 'src/app/types/CCP/permissionFolderCCP.type';
import { GeneralRoleCDMS, typeSystemRoleCDMS } from 'src/app/types/General/RoleCDMS.type';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';



@Component({
    selector: 'app-version-history-ccp',
    templateUrl: './version-history-ccp.component.html',
    styleUrls: ['./version-history-ccp.component.scss', '../../../../Styles/GlobalStyles.css', '../../../../Styles/VersionHistoryGlobal.css'],
    standalone: false
})
export class VersionHistoryCCPComponent implements OnInit {

  //+================== VARIABLES FOR ICONS ==================+\\
  public Icons = [
    { Icon: 'fa-user-pen', Description: 'La HOE está siendo revisada' },
    { Icon: 'fa-user-clock', Description: 'El usuario está esperando a que llegue La HOE' },
    { Icon: 'fa-user-check', Description: 'La HOE ha sido revisada y aprobada' },
    { Icon: 'fa-user-xmark', Description: 'La HOE ha sido revisada y cancelada' },
    { Icon: 'fa-user-shield', Description: 'La HOE ha sido aprobada por un administrador' },
    { Icon: 'fa-user-shield', Description: 'La HOE ha sido rechazada por un administrador' },
    { Icon: 'fa-users-slash', Description: 'No existe revisor o aprobador' },
    { Icon: 'fa-person-circle-question', Description: 'No Se tienen datos del revisor o aprobador, la HOE puede ser muy antigua' }
  ];

  //+================== VARIABLES FOR HEADERS FM ==================+\\
  public HeadersVH: Headers_CCP[] = [
    { ID: 1, Name: 'Descargar', Position: 1, Visible: true, Key_Header: 'DOW' },
    { ID: 1, Name: 'Nombre de CCP', Position: 1, Visible: true, Key_Header: 'NAM' },
    { ID: 1, Name: 'Revisión', Position: 1, Visible: true, Key_Header: 'NOR' },
    { ID: 1, Name: 'Año de modelo', Position: 1, Visible: true, Key_Header: 'MOY' },
    { ID: 1, Name: 'Código', Position: 1, Visible: true, Key_Header: 'COD' },
    { ID: 1, Name: 'Folio', Position: 1, Visible: true, Key_Header: 'INV' },
    { ID: 1, Name: 'Contribuidor', Position: 1, Visible: true, Key_Header: 'CON' },
    { ID: 1, Name: 'Fecha de carga', Position: 1, Visible: true, Key_Header: 'DAC' },
    { ID: 1, Name: 'Fecha de aprobación', Position: 1, Visible: true, Key_Header: 'DEE' },
    { ID: 1, Name: 'Revisor', Position: 1, Visible: true, Key_Header: 'REV' },
    { ID: 1, Name: 'Aprobador', Position: 1, Visible: true, Key_Header: 'APP' },
    { ID: 1, Name: 'Estatus ', Position: 1, Visible: true, Key_Header: 'STA' },
  ]

  //+================== VARIABLES FOR SEARCH ==================+\\
  public Filter_VersionH: string = '';


  //+================== VARIABLES FOR KEYS SNAPSHOTS ==================+\\
  private ID_Folder: number = 0;
  private ID_DocCCP: number = 0;


  //+================== VARIABLE FOR ALL VERSION CCP ==================+\\
  public List_Histrory_Version_CCP: VH_FILE_CCP[] = [];
  public SelectedList_Histrory_Version_CCP: VH_FILE_CCP[] = [];

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  //+================== VARIABLE PERMISION ==================+\\
  private Permission_FMH: tpermissionFolderCCP[] = [];
  public PermissionCCP: PermissionSystemFolderCCPType = permissionSystemFolderCCP;

  //+================== VARIABLE ROLES GENERAL ==================+\\
  public RolesGeneral: typeSystemRoleCDMS = GeneralRoleCDMS;

  //+================== VARIABLES FOR CREDENTIALS USER ==================+\\
  private ID_User_BD: number = 0;

  //+================== FOR FILTERS ==================+\\
  public Filter_Global_Check: Filter_Check_CCP = {
    Extension: [],
    Model_Year: [],
    Status: [],
    Reviewer_Name: [],
    Approver_Name: [],
    Contributor_Name: [],
  };

  //+================== VARIABLE FOR ALL VERSION CCP ==================+\\
  public LoadPage: boolean = false;
  public UserService = inject(UserDataService);

  constructor(private Service_CCP: LIBRARYCCPService, private activatedRouter: ActivatedRoute, private PermissionFolder: PermisionsFolderService) {
    this.ID_Folder = this.activatedRouter.snapshot.params['idF'];
    this.ID_DocCCP = this.activatedRouter.snapshot.params['idH'];
    this.ID_User_BD = Number(localStorage.getItem('ID_U_DB'));
  }

  ngOnInit(): void {
    this.Load_Component_VH();
  }


  private async Load_Component_VH(): Promise<void> {

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {

      const Permisions_Level: Permission_Folder_CCP = await this.PermissionFolder.GetPermissionsInFolderCCP(this.ID_User_BD, this.ID_Folder);

      this.Permission_FMH = Permisions_Level.Permission;

      const ResVersionHistory: Response_CCP = await firstValueFrom(this.Service_CCP.GetVersionHistory({ ID_WF: this.ID_DocCCP }));

      if (ResVersionHistory.success) {
        this.List_Histrory_Version_CCP = ResVersionHistory.operation;

        this.Generate_Filters();
      }

      Loader.classList.remove('active');
      this.LoadPage = true;


    } catch (e) {

      Swal.fire({
        title: 'Error',
        text: '¡Error al cargar el historial de versiones de la HOE, informa a tu supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })

      Loader.classList.remove('active');
      this.LoadPage = true;
    }

  }


  //&===================== FUNCTION FOR FILTERS =====================&\\

  private Generate_Filters(): void {

    this.Filter_Global_Check = {
      Extension: [],
      Model_Year: [],
      Status: [],
      Reviewer_Name: [],
      Approver_Name: [],
      Contributor_Name: [],
    };

    for (const CCP of this.List_Histrory_Version_CCP) {

      CCP.Date_Created = moment(CCP.Date_Created).utc().toDate();
      CCP.Date_Expiration = moment(CCP.Date_Expiration).utc().toDate();
      CCP.Date_End = moment(CCP.Date_End).utc().toDate();


      if (!this.Filter_Global_Check.Model_Year.includes(CCP.Model_Year) && CCP.Model_Year !== null) {
        this.Filter_Global_Check.Model_Year.push(CCP.Model_Year);
      }

      if (!this.Filter_Global_Check.Status.includes(CCP.Status) && CCP.Status !== null) {
        this.Filter_Global_Check.Status.push(CCP.Status);
      }

      if (!this.Filter_Global_Check.Reviewer_Name.includes(CCP.Reviewer_Name) && CCP.Reviewer_Name !== null) {
        this.Filter_Global_Check.Reviewer_Name.push(CCP.Reviewer_Name);
      }

      if (!this.Filter_Global_Check.Approver_Name.includes(CCP.Approver_Name) && CCP.Approver_Name !== null) {
        this.Filter_Global_Check.Approver_Name.push(CCP.Approver_Name);
      }

      if (!this.Filter_Global_Check.Contributor_Name.includes(CCP.Contributor_Name) && CCP.Contributor_Name !== null) {
        this.Filter_Global_Check.Contributor_Name.push(CCP.Contributor_Name);
      }

    }

  }

  //&===================== END FUNCTION FOR FILTERS =====================&\\




  //&===================== FUNCTIONS FOR GENERAL VERSION HISTORY =====================&\\

  public ToggleModalHelp(CloseOrOpen: boolean): void {
    const ModalIconsHelp = document.getElementById('ModalIconsHelp') as HTMLDivElement;
    CloseOrOpen ? ModalIconsHelp.classList.add('active') : ModalIconsHelp.classList.remove('active');
  }

  public DateFormat(Date_Created: Date): string {
    return moment(Date_Created).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  public DateFormat_Approved(Date: string | Date, Status: number): string {
    return Status === 2 ? ("N/A") : (moment(Date).utc().format('DD/MM/YYYY hh:mm:ss a'));
  }

  public Status_string(Status: number): string {
    switch (Status) {
      case 1: return 'Aprobada';
      case 2: return 'Pendiente';
      case 3: return 'Rechazada';
      case 4: return 'Eliminada';
      default: return '';
    }
  }

  public SeeReason_Reviewer(CCP: VH_FILE_CCP): void {

    let Comment: string | null = null;

    if (CCP.TaskReviewer.Comment != null) {
      Comment = CCP.TaskReviewer.Comment;
    }

    if (Comment === null) {
      Comment = 'El archivo fue rechazado en el antiguo sistema o sucedió algún inconveniente y no tenemos la razón de rechazo.'
    }

    if (CCP.Status === 3 && CCP.TaskReviewer.Status === 4) {

      Swal.fire({
        title: 'Comentarios',
        text: `¡${Comment}!`,
        confirmButtonColor: this.ColorConfirm
      })

    } else if (CCP.TaskReviewer.Status === 6) {
      Swal.fire({
        title: 'Comentarios',
        html: `¡La CCP fue rechazada por el administrador <b>${CCP.TaskReviewer.FlowAdminName}</b>!<br><br><b>Comentario: </b>${Comment}`,
        confirmButtonColor: this.ColorConfirm
      })
    }
  }

  public SeeReason_Approver(CCP: VH_FILE_CCP): void {

    let Comment: string | null = null;

    if (CCP.TaskApprover.Comment != null) {
      Comment = CCP.TaskApprover.Comment;
    }

    if (Comment === null) {
      Comment = 'El archivo fue rechazado en el antiguo sistema o sucedió algún inconveniente y no tenemos la razón de rechazo.'
    }

    if (CCP.Status === 3 && CCP.TaskApprover.Status === 4) {

      Swal.fire({
        title: 'Comentarios',
        text: `¡${Comment}!`,
        confirmButtonColor: this.ColorConfirm
      })

    } else if (CCP.TaskApprover.Status === 6) {
      Swal.fire({
        title: 'Comentarios',
        html: `¡La CCP fue rechazada por el administrador <b>${CCP.TaskApprover.FlowAdminName}</b>!<br><br><b>Comentario: </b>${Comment}`,
        confirmButtonColor: this.ColorConfirm
      })
    }
  }

  public SeeToolTip_Rejected_Reviewer(CCP: VH_FILE_CCP): boolean {

    return (CCP.Status === 3 && (CCP.TaskReviewer.Status === 4 || CCP.TaskReviewer.Status === 6))

  }

  public SeeToolTip_Rejected_Approver(CCP: VH_FILE_CCP): boolean {

    return (CCP.Status === 3 && (CCP.TaskApprover.Status === 4 || CCP.TaskApprover.Status === 6))

  }

  public SeeToolTip_Approved_Admin_Reviwer(CCP: VH_FILE_CCP): boolean {
    return (CCP.Status === 1 && CCP.TaskReviewer.Status === 5)
  }

  public SeeToolTip_Approved_Admin_Approver(CCP: VH_FILE_CCP): boolean {
    return (CCP.Status === 1 && CCP.TaskApprover.Status === 5)
  }

  public seeApproverAdmin_Approver(CCP: VH_FILE_CCP): void {
    if (CCP.Status === 1 && CCP.TaskApprover.Status === 5) {

      Swal.fire({
        title: 'Usuario administrador aprobador',
        text: `¡${CCP.TaskApprover.FlowAdminName}!`,
        confirmButtonColor: this.ColorConfirm
      })

    }
  }

  public seeApproverAdmin_Reviewer(CCP: VH_FILE_CCP): void {
    if (CCP.Status === 1 && CCP.TaskReviewer.Status === 5) {

      Swal.fire({
        title: 'Usuario administrador aprobador',
        text: `¡${CCP.TaskReviewer.FlowAdminName}!`,
        confirmButtonColor: this.ColorConfirm
      })

    }
  }

  //&===================== END FUNCTIONS FOR GENERAL VERSION HISTORY =====================&\\




  //&===================== FUNCTIONS FOR PERMISSIONS =====================&\\

  //-================== FUNCTIONS FOR PERMISSIONS ==================-\\
  public UserRoleIn(Permissions: tpermissionFolderCCP[]): boolean {

    for (const Role of this.Permission_FMH) {
      const PermissionsFound = Permissions.find((p: tpermissionFolderCCP) => {
        return (p.toUpperCase() === Role.toUpperCase());
      })
      if (PermissionsFound) {
        return true;
      }

    }

    return false;

  }

  //&===================== END FUNCTIONS FOR PERMISSIONS =====================&\\




  //&===================== FUNCTIONS FOR DOWNLOAD FILE =====================&\\

  public async Check_Version_CCP(CCP: VH_FILE_CCP, Position: number): Promise<void> {

    try {

      if (CCP.ID_Next_Version === null) {

        const Res_Get_URL: Response_CCP = await firstValueFrom(this.Service_CCP.Get_URL_DownloadCCP({ ID_CCP: CCP.ID, Type_D: Download_Log_CCP.D_VERSION_HISTO }));

        if (Res_Get_URL.success) {
          this.DownloadFile(Res_Get_URL.operation.URL_CCP, Position, CCP.Name);
        } else {
          throw "error";
        }

      } else {

        const Res_Get_URL: Response_CCP = await firstValueFrom(this.Service_CCP.Get_URL_Last_Version_DownloadCCP({ ID_CCP: CCP.ID, Type_D: Download_Log_CCP.D_VERSION_HISTO }));

        if (Res_Get_URL.success) {
          this.DownloadFile(Res_Get_URL.operation.URL_CCP, Position, CCP.Name);
        } else {
          throw "error";
        }

      }

    } catch (e) {
      Swal.fire({
        title: 'Error',
        text: '¡Error al descargar la HOE, informa a tu supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }

  }

  public async DownloadFile(URL: string, Position: number, Name_File: string): Promise<void> {

    try {

      const Btn_Download = document.getElementById(`Btn-Download${Position}`) as HTMLDivElement;
      const Progress_Bar_Task = document.getElementById(`Progress-Bar-Task${Position}`) as HTMLSpanElement;


      this.Service_CCP.DownloadCCP(URL).subscribe((event: any) => {

        const Text_Btn = document.getElementById(`Text-Btn${Position}`) as HTMLElement;
        const Icon_Btn = document.getElementById(`Icon-Btn${Position}`) as HTMLElement;
        Btn_Download.classList.add('active');

        if (event.status === 404) {
          Btn_Download.classList.remove('active');
          Progress_Bar_Task.style.width = '0%';
          Icon_Btn.classList.replace('fa-cloud-arrow-down', 'fa-xmark');
          Text_Btn.innerHTML = 'Error';

          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'error',
            title: '¡Error al descargar la HOE, informa a tu supervisor!'
          })

        }

        if (event['loaded'] && event['total']) {

          let Discharge_Rate: number = Math.round(event['loaded']) / event['total'] * 100;

          Progress_Bar_Task.style.width = Discharge_Rate + '%';

        }
        if (event['body']) {

          Progress_Bar_Task.style.width = '0%';
          Btn_Download.classList.remove('active');

          if (event.status === 200) {

            Icon_Btn.classList.replace('fa-cloud-arrow-down', 'fa-check-double');
            Text_Btn.innerHTML = 'Completada';

            const Toast = Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 1500,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            })

            Toast.fire({
              icon: 'success',
              title: 'HOE descargada!'
            })

            saveAs(event['body'], Name_File);
          }

        }
      })

    } catch (e) {
      Swal.fire({
        title: 'Error',
        text: '¡Error al descargar la HOE, informa a tu supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }

  }

  //&===================== END FUNCTIONS FOR DOWNLOAD FILE =====================&\\

}
